import { EmptystateDataFlowColored, External } from "components/icons/generated";
import LinkButton from "ds/components/Button/LinkButton";
import EmptyState from "ds/components/EmptyState";

const FlowsProjectsUnlinked = () => (
  <EmptyState
    icon={EmptystateDataFlowColored}
    title="Link your Flows organization"
    caption="Spacelift Flows automates your day-2 operations. Connect your Spacelift account to a new or existing Flows organization to manage project roles here."
  >
    <LinkButton
      variant="primary"
      endIcon={External}
      href="/flows/link/select"
      target="_blank"
      rel="noopener noreferrer"
    >
      Link organization
    </LinkButton>
  </EmptyState>
);

export default FlowsProjectsUnlinked;
